import { inject, Service } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { EventBusService } from '@shared';
import { map, Observable } from 'rxjs';
import { DEFAULT_FOOTER_CONFIGURATION, FOOTER_EVENTS, FooterConfigurationEvent } from './footer-events.model';

/**
 * App Footer Event Consumer
 *
 * Consumes configuration events from feature modules to update footer appearance.
 */
@Service()
export class FooterEventConsumerService {
	private readonly eventBus = inject(EventBusService);

	readonly configuration$: Observable<Required<FooterConfigurationEvent>> = this.eventBus
		.on$<FooterConfigurationEvent>(FOOTER_EVENTS.CONFIGURATION)
		.pipe(map(wrapped => ({ ...DEFAULT_FOOTER_CONFIGURATION, ...wrapped?.data })));

	readonly configuration = toSignal(this.configuration$, {
		initialValue: DEFAULT_FOOTER_CONFIGURATION
	});
}
